module.exports = __webpack_public_path__ + "static/img/hoangminhduc.04c54da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hoangminhduc.png
// module id = sLr+
// module chunks = 1